// extracted by mini-css-extract-plugin
export default {"name":"UserStatus__name--7EitC","icon":"UserStatus__icon--0De4y","content":"UserStatus__content--Hdk-z"};